module.exports = __webpack_public_path__ + "img/jsfni7.22eba4c1.png";